import React from 'react';

const PoweredByHeader: React.FC = () => {
  return (
    <>
      <div className="float-right">
        Powered by Evestment
      </div>
      <p>
        Upload existing Portfolio Analytics selection sets, entities, or investment edges directly
        into eVestment.
      </p>
    </>
  );
};

export default PoweredByHeader;
